import React, { Component } from 'react';

import logoUrl from '../../lendnation-logo-v2.svg';
import { Col, Row } from 'react-bootstrap';

function Logo({ store }) {
  return (
    <header className="apply-now-header">
      <div>
        <div className="cashmax-menu">
          <Row className="ps-5 pt-3 pe-5 pb-5">
            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
              <div className="pt-3">
                <a href="https://www.lendnation.com/">
                  <img
                    src={logoUrl}
                    alt="CashMax"
                    className="img-responsive logo-img"
                  />
                </a>
              </div>
            </Col>
            <Col xs={12} sm={6} md={6} lg={6} xl={6}>
              {store ? (
                <div className="phone-header">
                  <div className="phone-div pt-3">
                    <a href={'tel: ' + store.phone}>
                      <span className="phone-button">
                        {store.phone.startsWith('+1')
                          ? store.phone
                          : '+1 ' + store.phone}
                      </span>
                    </a>
                  </div>
                </div>
              ) : (
                <div></div>
              )}
            </Col>
          </Row>
        </div>
        <div className="clearNone"></div>
      </div>
    </header>
  );
}
export default Logo;
